package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class MedicalRecordDiagnosisDiagnosisSource(private val literal: String) : IEnumType {
	系统建议("系统建议"),
	医生("医生");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "medical_record_diagnosis_diagnosis_source"}
	override fun getLiteral(): String {return literal}
}
